/* global SERVER_URL */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import fetch from 'isomorphic-fetch';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import ExploreAuth from '../../utils/ExploreAuth';
import { checkHttpStatus, parseJSON } from '../../utils';
import { setUserRatedSnapshots } from '../../actions/auth';
import Ratings from '../Ratings';

const propTypes = {
  rating: PropTypes.number,
  snapshotId: PropTypes.string.isRequired,
  userSnapshotRatings: PropTypes.shape({}),
  updateRatings: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  iconDimensions: PropTypes.string,
};

const defaultProps = {
  rating: 0,
  userSnapshotRatings: {},
  iconDimensions: '20px',
};

class SnapshotRating extends Component {
  constructor(props) {
    super(props);

    this.changeRating = this.changeRating.bind(this);
    this.state = {
      rating: this.props.rating || 0,
    };
  }

  changeRating(rating) {
    const { snapshotId, updateRatings } = this.props;
    this.setState({
      rating,
    });
    ExploreAuth.getValidJwt()
      .then((tokenIsValid) => {
        if (tokenIsValid) {
          fetch(`${SERVER_URL}/snapshots/rate/${snapshotId}`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${ExploreAuth.getJwt()}`,
            },
            body: JSON.stringify({ rating }),
          })
            .then(checkHttpStatus)
            .then(parseJSON)
            .then((response) => {
              if (response.data) {
                updateRatings(response.data.ratings);
              }
            })
            .catch((error) => {
              console.log(error, 'An error occurred');
            });
        }
      });
  }

  render() {
    const { userSnapshotRatings, snapshotId, isAuthenticated, iconDimensions } = this.props;
    const userHasRated = (userSnapshotRatings[snapshotId]) ? true : false;
    const rating = userSnapshotRatings[snapshotId] || this.state.rating;
    return (
      <span
        data-tip
        data-for="rate"
      >
        <Ratings
          rating={rating}
          widgetRatedColors={userHasRated ? '#e20000' : '#ffffff'}
          changeRating={this.changeRating}
          widgetDimensions={iconDimensions}
          widgetHoverColors="#ff0000"
          widgetEmptyColors="transparent"
          widgetSpacings="5px"
          svgIconViewBoxes="0 0 512 512"
          svgIconPaths="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
        >
          <Ratings.Widget />
          <Ratings.Widget />
          <Ratings.Widget />
        </Ratings>
      </span>
    );
  }
}

SnapshotRating.propTypes = propTypes;
SnapshotRating.defaultProps = defaultProps;


const mapStateToProps = (state) => {
  return {
    userSnapshotRatings: (Array.isArray(state.auth.snapshotRatings)  && state.auth.snapshotRatings.length === 0) ? {} : state.auth.snapshotRatings,
    isAuthenticated: state.auth.isAuthenticated,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateRatings: ratings => dispatch(setUserRatedSnapshots(ratings)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SnapshotRating);
